import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const loadScript = (src) =>
  new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const startCheckout = async ({ product, buyer, brandName, onSuccess }) => {
  const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
  if (!ok) {
    toast.error("Could not load payment gateway. Check your connection.");
    return;
  }
  let order;
  try {
    const { data } = await axios.post(`${API}/orders/create`, {
      product_name: product.name,
      amount_inr: product.priceInr || 100,
      buyer_name: buyer.name,
      buyer_email: buyer.email,
      buyer_phone: buyer.phone,
    });
    order = data;
  } catch (e) {
    const detail = e?.response?.data?.detail;
    toast.error(typeof detail === "string" ? detail : "Could not create order.");
    return;
  }

  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.razorpay_order_id,
    name: brandName || "Geomantic Kalpataru",
    description: product.name,
    prefill: { name: buyer.name, email: buyer.email, contact: buyer.phone },
    theme: { color: "#D4AF37" },
    handler: async (resp) => {
      try {
        await axios.post(`${API}/orders/verify`, {
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
          order_ref: order.order_ref,
        });
        toast.success("Payment received. We'll reach out on WhatsApp shortly.");
        onSuccess && onSuccess();
      } catch (e) {
        toast.error("Payment received but verification failed. Contact us with your payment ID.");
      }
    },
    modal: {
      ondismiss: () => toast.message("Checkout closed."),
    },
  });
  rzp.on("payment.failed", () => toast.error("Payment failed. Please try again."));
  rzp.open();
};
